import { FC } from "react";
import { RenderQuestionToDisplay } from "..";
import { IChallengeCardsBoard } from "../../../interfaces";

interface IQuestionCardOnTheTable {
    challengeCard: IChallengeCardsBoard;
    dilemmaOwnerImage: any;
}

const QuestionCardOnTheTable: FC<IQuestionCardOnTheTable> = (props) => {
    const { challengeCard, dilemmaOwnerImage } = props;

    return (
        <div className="full_absolute_screeen">
            <div className="full_screen center_horizontally_and_vertically">
                <RenderQuestionToDisplay challengeCard={challengeCard} dilemmaOwnerImage={dilemmaOwnerImage} />
            </div>
        </div >
    )
}

export default QuestionCardOnTheTable;